import React, { useCallback, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { BiData } from '@wix/da-bi/pkg/events';
import { useRestrictToLoggedIn } from '../../../../utils/hooks/useRestrictToLoggedIn';
import { usePushModal } from '../../../../utils/hooks/usePushModal';
import { ModalType } from '../../../../Modals/redux/types';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import SuffixText from '../_partials/SuffixText';
export function useAISuppressionItem() {
    const { t } = useTranslation();
    const { aiContentFilter } = useContext(SessionContext);
    const pushAISuppressionModal = usePushModal(ModalType.AI_SUPPRESSION_SETTINGS);
    return {
        key: 'ai-suppression',
        label: t('siteHeader.userMenu.aiContent.loggedIn.label'),
        suffix: /*#__PURE__*/ React.createElement(SuffixText, null, aiContentFilter === 'suppress' ? t('siteHeader.userMenu.aiContent.loggedIn.suffix.suppressing') : t('siteHeader.userMenu.aiContent.loggedIn.suffix.allowing')),
        onClick: ()=>pushAISuppressionModal(),
        biData: BiData({
            evid: 702,
            menu_name: 'profile',
            menu_item: 'ai-content'
        })
    };
}
export function useFakeAISuppressionItem() {
    const { t } = useTranslation();
    const [toggled, setToggled] = useState(false);
    const { sendUserToJoinPage } = useRestrictToLoggedIn();
    const handleChange = useCallback(()=>{
        setToggled(true);
        // note: fires bi event 240
        sendUserToJoinPage(ReferralType.TOPIC_WATCH_CHANGE);
    }, [
        sendUserToJoinPage
    ]);
    return {
        key: 'ai-suppression',
        label: t('siteHeader.userMenu.aiContent.anon.label'),
        size: 'medium',
        checked: toggled,
        onChange: handleChange
    };
}

//# sourceMappingURL=useAISuppressionItem.js.map